import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth';
import error from './error';
import store from "../store";
import MenuUtils from '@/utils/menuUtils'
import rejectApprovalShow from '../page/reject/rejectApprovalShow/rejectApprovalShow.vue'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    redirect: 'page_home_home'
  },
  {
    path: '/reject_approval_show',
    component: rejectApprovalShow
  },
  ...auth,
  ...error
]

const router = new Router({
  mode: 'history', // require service support
  //base:'wds',   //wds
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

//刷新页面的时候先检查本地是否有路由数据 如果没有就请求新的数据
let menus = JSON.parse(window.sessionStorage.getItem("menus_new"));
if (menus) {
  if (!store.state.tagsView.sidebar.opened) {
    store.dispatch('tagsView/toggleSideBar')
  }
  let routes = [];
  MenuUtils(routes, menus);

  router.addRoutes(routes);

}
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  console.log('===to===', to)
  console.log('===from===', from)
  //邮件
  if(to.path == '/approve_show' || to.path == '/reject_approval_show'){
    console.log('===before next===')
    next();
  } else {

  let data = JSON.parse(window.sessionStorage.getItem('menus_new'));
  //退出登录来这里
  if (data && to.path === '/login') {
    //这里不使用router进行跳转，是因为，跳转到登录页面的时候，是需要重新登录，获取数据的，这个时候，会再次向router实例里面add路由规则，
    //而next()跳转过去之后，没有刷新页面，之前的规则还是存在的，但是使用location的话，可以刷新页面，当刷新页面的时候，整个app会重新加载
    //而我们在刷新之前已经把sessionStorage里的user移除了，所以上面的添加路由也不行执行
    window.sessionStorage.removeItem('menus_new');
    window.location.href = '/login';
  }
  if (!data && to.path !== '/login') {

    //打开动态二维码页面
    let rdcNo = to.query.rdcNo

    rdcNo ? next(`/login?rdcNo=${rdcNo}`) : next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role === 'admin' ? next() : next('/403');
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      });
    } else {
      next();
    }
  }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js